import React from "react";
import PGFacilitiesPage from "./PGFacilitiesPage";

const images = [
  {
    src: "/PG_images/thermal/ELGI (E07En).png",
    title: "ELGI Compressor",
    alt: "ELGI compressor facility",
  },
  {
    src: "/PG_images/thermal/FLUKE TI- 400.jpg",
    title: "FLUKE TI-400",
    alt: "FLUKE TI-400 thermal imaging equipment",
  },
  {
    src: "/PG_images/thermal/IC Engine Model.jpg",
    title: "IC Engine Model",
    alt: "IC engine model",
  },
  {
    src: "/PG_images/thermal/Pyranometer.jpg",
    title: "Pyranometer",
    alt: "Pyranometer equipment",
  },
  {
    src: "/PG_images/thermal/regulator.gif",
    title: "Regulator",
    alt: "Regulator equipment",
  },
  {
    src: "/PG_images/thermal/Wind Tunnels.jpg",
    title: "Wind Tunnels",
    alt: "Wind tunnels facility",
  },
];

const facilities = [
  "ELGI compressor",
  "FLUKE TI-400 thermal imaging equipment",
  "IC engine model",
  "Pyranometer",
  "Regulator equipment",
  "Wind tunnel facility",
  "Thermal systems practical learning resources",
  "Energy and heat transfer experimentation support",
];

const facts = [
  ["Programme", "M.Tech. Thermal Power Engineering"],
  ["Facility Type", "Thermal Engineering Laboratory"],
  ["Equipment Gallery", `${images.length} resources`],
  ["Department", "Mechanical Engineering"],
];

const ThermalPowerFacilities = () => (
  <PGFacilitiesPage
    title="Thermal Power Engineering Facilities"
    shortTitle="Thermal Power"
    programmePath="/programme/thermal-power-engineering"
    programmeLabel="Thermal Power Engineering"
    heroImage="/PG_images/thermal/Pyranometer.jpg"
    images={images}
    facilities={facilities}
    facts={facts}
  />
);

export default ThermalPowerFacilities;
